import { FormElement, Form } from '@progress/kendo-react-form'
import MessageAlert from 'components/Alerts/MessageAlert/MessageAlert'
import SaveButton from 'components/Buttons/SaveButton/SaveButton'
import CasesGrid from 'components/Cases/CasesGrid'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { focusFirstError } from 'core/helpers'
import { useEffect, useRef } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IRootState } from 'types'

interface IProps {
    dealerId: string
    editable: boolean
    formIsModified: boolean
}

const ClosedCasesForm = ({ dealerId, editable }: IProps) => {

    
    return (
        <div id='CloseCasesForm'>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light shadow-sm p-3 border pb-5'>
                            <Row>
                                <Col md={6}><h4>Closed Cases</h4></Col>
                                <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    {dealerId
                                        ?   <CasesGrid title={''} showClosedCases={true} showOpenCases={false} dealerId={parseInt(dealerId)} forDealerEditPage={true} hideCaseActions={true} />
                                        :   <MessageAlert alert={{ variant: 'danger', messages: ['Dealer Id is undefined.'] }} />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <Row className='my-4'>
                            <Col xs={12} sm={4}>
                                <SaveButton
                                    title={!editable ? DEFAULT_PERMISSION_MESSAGE : undefined}
                                    onClick={() => focusFirstError(formRenderProps)}
                                    type='submit' />
                            </Col>
                        </Row>

                    </FormElement>

                )
                }
            />
        </div>
    )
}
export default ClosedCasesForm